import { alpha, Divider, Stack, useTheme } from "@mui/material";
import Scrollbar from "src/components/Scrollbar";

import BrandAssets from "./sections/BrandAssets";
import ButtonsStyling from "./sections/ButtonsStyling";
import ByDefaultSection from "./sections/ByDefaultSection";
import ErrorSection from "./sections/ErrorSection";
import GeneralStyling from "./sections/GeneralStyling";
import TextsStrokes from "./sections/TextsStrokes";
import SumbitFooter from "./SumbitFooter";

export default function StylingPanel() {
	const theme = useTheme();
	return (
		<Stack
			sx={{
				borderRight: 0.5,
				borderColor: alpha(theme.palette.divider, 0.15)
			}}
		>
			<Scrollbar sx={{ p: 4, pb: 8, height: 715 }}>
				<BrandAssets />
				<Divider sx={{ my: 4, borderStyle: "dashed" }} />
				<GeneralStyling />
				<Divider sx={{ my: 4, borderStyle: "dashed" }} />
				<TextsStrokes />
				<Divider sx={{ my: 4, borderStyle: "dashed" }} />
				<ButtonsStyling />
				<Divider sx={{ my: 4, borderStyle: "dashed" }} />
				<ErrorSection />
				<Divider sx={{ my: 4, borderStyle: "dashed" }} />
				<ByDefaultSection />
				<Divider sx={{ my: 4, borderStyle: "dashed" }} />
			</Scrollbar>
			<SumbitFooter />
		</Stack>
	);
}
